import React, { Component } from 'react';
import {translate} from 'react-i18next';
import errorImage from '../../assets/images/errors/pizza.svg'


class Error500View extends Component {
  render() {
    const {t} = this.props;
    return (
      <div className="error-wrapper">
        <div className="error-message error-message--e500">
          <div className="error-message__image error-message__image--e500">
            <img src={errorImage} alt=""/>
          </div>

          <div className="error-message__text-block">
            <div className="error-message__text">
              {t('error_404')}
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default translate('translations')(Error500View);



// WEBPACK FOOTER //
// ./src/components/App/Error500View.js